// Single menu item for non-master users (appears in Lotto section)
export default [
  {
    title: 'รายการน่าสงสัย',
    icon: 'EyeIcon',
    route: 'fraud-detection-activities',
    action: ['read'],
    resource: 'lotto',
  },
]
